module.exports = __webpack_public_path__ + "static/media/waterOn.b304e692.svg";